import { fieldVisibilityConfig } from '../config/fieldVisibilityConfig';


export const isFieldVisibleByRole = (field, role) => {
    const formattedField = field.endsWith('Id') ? field.slice(0, -2) : field;

    const allowedRoles = fieldVisibilityConfig[formattedField];

    if (Array.isArray(allowedRoles)) {
        return allowedRoles.includes(role);
    }

    return true;
};

export const isFieldInVisibleSet = (field, visibleSet) => {
    const key = field.id;
    const object = field.cell === 'SelectObject' ? field.object : null;

    if (visibleSet.has(key)) return true;
    if (object && visibleSet.has(`${key}.${object}`)) return true;

    const hasConfigForField = Object.keys(fieldVisibilityConfig).some(
        (k) => k === key || k.startsWith(`${key}.`)
    );

    return !hasConfigForField;
};

export const getVisibleFieldSet = (role) => {
    const visibleFields = new Set();

    for (const key in fieldVisibilityConfig) {
        const allowedRoles = fieldVisibilityConfig[key];
        if (!allowedRoles || allowedRoles.includes(role)) {
            visibleFields.add(key);
        }
    }

    return visibleFields;
};
